<template>
  <div>
    <h1 class="title font-weight-bold mt-2 mb-4">Previsão para hoje</h1>
    <v-row class="white--text" align="center">
      <v-col
        class="py-0"
        cols="12"
        sm="6"
        md="6"
        align-self="start"
        align="start"
      >
        <v-icon
          class="mr-2"
          size="16"
          color="white"
          style="
            height: 24px;
            width: 24px;
            border-radius: 50%;
            background-color: #69d7a3;
          "
          >icon-infohidro-bacia</v-icon
        >
        <span v-if="location" class="ml-2">{{ location.text }}</span>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row justify="center" align="center">
      <v-col v-if="showAnimation" cols="12">
        <v-card max-width="3000" max-height="300" color="primary darken-1">
          <div style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
      </v-col>
      <v-col v-else cols="12">
        <monitoring-daily-forecast-mobile
          v-if="this.$vuetify.breakpoint.name === 'xs'"
          :values="values"
          :flow="flow"
          :quality="quality"
          :availability="availability"
          :date="date"
        />
        <monitoring-daily-forecast-responsive
          v-else
          :values="values"
          :flow="flow"
          :quality="quality"
          :availability="availability"
          :date="date"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MonitoringDailyForecastResponsive from './MonitoringDailyForecastResponsive';
import moment from 'moment';
import LoadingAnimation from '../common/LoadingAnimation.vue';
import MonitoringDailyForecastMobile from './MonitoringDailyForecastMobile';
import {loadIndicatorIceLatest} from '@/api/priv/ice-latest';
export default {
  components: {
    MonitoringDailyForecastMobile,
    MonitoringDailyForecastResponsive,
    LoadingAnimation,
  },
  props: ['location'],
  name: 'MonitoringDailyForecast',
  data() {
    return {
      values: false,
      flow: false,
      quality: false,
      availability: false,
      loading: true,
      date: false,
      showAnimation: false,
      today: moment().format('YYYY-MM-DD'),
    };
  },
  watch: {
    location(properties) {
      if (properties) {
        this.initialize(properties);
      }
    },
  },
  mounted() {
    if (this.location) {
      this.initialize(this.location);
    }
  },
  methods: {
    suffix(value) {
      if (value <= 5) {
        return 'Cheia';
      } else if (value >= 6 && value <= 24) {
        return 'Rio alto';
      } else if (value >= 25 && value <= 74) {
        return 'Normal';
      } else if (value >= 75 && value <= 94) {
        return 'Rio baixo';
      } else if (value >= 95) {
        return 'Estiagem';
      }
    },
    async initialize(properties) {
      this.loading = true;
      this.showAnimation = true;
      await this.fetchWaterQuality();
      await this.$store.dispatch('loadWaterAvailability', {
        location_id: properties.locationid,
      });
      let availability = this.$store.getters.waterAvailability;
      if (availability) {
        for (let item in availability) {
          if (availability[item].date === this.today) {
            this.availability = Object.assign({}, availability[item]);
            this.availability.date = this.availability.date
              ? moment(this.availability.date, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY',
                )
              : '##/##/####';
            this.availability.q30 = this.availability.q30 * 100;
            this.availability.q30 = Math.round(this.availability.q30);
            this.availability.suffix = this.suffix(this.availability.q30);
          }
        }
      }
      await this.$store.dispatch('loadMonitoringDailyForecast', {
        type: 'daily',
        source: '22',
        location_id: properties.locationid,
      });
      let response = this.$store.getters.monitoringDailyForecast;
      if (response[0] && response[0].value) {
        this.values = response[0].value[0];
        let updated = response[0].updated;
        this.date = moment(updated, 'YYYY-MM-DDTHH:mm:ss+00:00').format(
          'DD/MM/YYYY',
        );
      }
      await this.$store.dispatch('loadMonitoringDailyForecastFlows', {
        type: 'daily',
        source: '2',
        location_id: properties.locationid,
        runtime: moment().subtract(1, 'days').utc().startOf('day').format(),
      });
      let flows = this.$store.getters.monitoringDailyForecastFlows;
      if (flows[0] && flows[0].value) {
        let yesterday = flows[0].value[0];
        let today = flows[0].value[1];
        let trend = '';
        if (today && yesterday) {
          if (today.flow === yesterday.flow) {
            trend = 'equal';
          } else if (today.flow > yesterday.flow) {
            trend = 'up';
          } else if (today.flow < yesterday.flow) {
            trend = 'down';
          }
        }
        this.flow = {
          value: today?.flow,
          trend: trend,
          date:
            today && today.date
              ? moment(today.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : undefined,
        };
      }
      this.loading = false;
    },
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },

    async fetchWaterQuality() {
      await this.$store.dispatch('loadSiaDetails', {
        location_id: this.location?.locationid,
      });
      const sia = await this.$store.getters.siaDetails;
      try {
        const payload = {
          sia: sia.locacronymn,
        };
        const response = await loadIndicatorIceLatest(payload);
        this.quality = response.data[0] || {};
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped></style>
